angular.module('zc.zenclerkS')
  .component('zcsCampaignListConversions', {
    bindings: {
      campaign: '<',
      project: '<',
      startAt: '<',
      endAt: '<',
    },
    templateUrl: '/templates/zenclerk_s/directives/campaign/list/conversions.html',
    controller: zcsCampaignListConversionsController,
  });

zcsCampaignListConversionsController.$inject = ['$q', '$translate', 'MongoCampaign', 'MongoConversion', 'ZcsDeviceName', 'currencies'];
function zcsCampaignListConversionsController($q, $translate, MongoCampaign, MongoConversion, ZcsDeviceName, currencies) {
  const vm = this;
  const CSV_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
  const pagination = {
    itemsPerPage: 10,
    currentPage: 1,
    maxSize: 8
  };

  vm.$onInit = () => {
    vm.currency = currencies[vm.project.currency];
    vm.conversions = [];
    vm.conversionCountPerDevice = {};
    vm.sortCurrent = 'created_at';
    vm.sortReverse = true;
    vm.headers = [
      { title: $translate.instant('directives.campaign.list.cvDate'), field: 'created_at', displayTitle: true },
      { title: $translate.instant('directives.campaign.list.id'), field: 'id', displayTitle: true },
      { title: $translate.instant('directives.common.device'), field: 'device', displayTitle: true },
      { title: $translate.instant('directives.campaign.list.purchasePrice'), field: 'price', displayTitle: true },
    ];
    // Header columns for:
    // - Conversion table
    // - CSV Export
    // If the displayTitle parameter is  false, the header will not be shown on the conversion table.
    vm.headerRow = _.map(vm.headers, 'title');
    vm.fields = _.map(vm.headers, 'field');
    vm.getCSV = getCSV;

    vm.pagination = pagination;
    vm.pageChanged = pageChanged;
    vm.sortBy = sortBy;
    vm.isOnlyOneDay = isOnlyOneDay;
    vm.getDevicePercentage = getDevicePercentage;
    vm.getDeviceName = ZcsDeviceName.getDeviceName;

    vm.limitedTo = pagination.itemsPerPage;
    vm.limitFilter = pagination.itemsPerPage;
    vm.chartData = {};
  };

  vm.$onChanges = () => {
    if(!vm.campaign || !vm.startAt || !vm.endAt || !vm.project) {
      return;
    }

    // avoid multiple onChanges calls
    if(vm.gettingConversions) return;
    vm.gettingConversions = true;

    let promise;
    if(vm.project.invoice_calculation_type === 'normal') {
      promise = getCouponCodeConversions();
    } else if(vm.project.invoice_calculation_type === 'deemed') {
      promise = getCampaignConversions();
    } else {
      throw new Error('invalid invoice calculation type');
    }

    promise.finally(() => {
      vm.gettingConversions = false;
    });
  };

  function getCampaignConversions() {
    const campaignsParams = {
      apikey: vm.project.apikey,
      campaign_id: vm.campaign.id,
      created_at: {
        $gte: vm.startAt,
        $lt: vm.endAt,
      },
      is_control: false,
      is_exclude: false,
    };

    return MongoCampaign.find(campaignsParams, {
      sort: { created_at: -1 },
      fields: ['_usid', 'created_at'],
      limit: 20000
    }).then(sentCampaigns => {
      const usids = _.map(sentCampaigns, d => d._usid);
      // too long requests fail on facade so split into smaller ones
      const chunks = _.chunk(usids, 50);

      const promises = _.map(chunks, chunk => {
        const conversionsParams = {
          apikey: vm.project.apikey,
          created_at: {
            $gte: vm.startAt,
            $lt: vm.endAt,
          },
          is_exclude: false,
          _usid: { $in: chunk }
        };

        return MongoConversion.find(conversionsParams, {
          sort: { created_at: -1 },
          fields: vm.fields,
        });
      });

      return $q.all(promises)
        .then(conversionResults => {
          const conversions = _.flatten(conversionResults);
          vm.conversions = _.uniqBy(_.sortBy(conversions, d => -d.created_at), d => d.id);
          vm.averageConversionPrice =
            _.sumBy(vm.conversions, d => d.price) / vm.conversions.length;
          vm.conversionCountPerDevice = _.countBy(vm.conversions, d => d.device);
          vm.pagedConversions = vm.conversions;
          vm.chartData.devices = getDevicesChartData(vm.conversionCountPerDevice);
        });
    });

  }

  function getCouponCodeConversions() {
    return MongoConversion.find({
      apikey: vm.project.apikey,
      created_at: {
        $gte: vm.startAt,
        $lt: vm.endAt,
      },
      is_exclude: false,
      coupon_code: vm.campaign.incentives[0].coupon_code
    }, {
      sort: { created_at: -1 },
      fields: vm.fields,
    }).then(conversions => {
      vm.conversions = _.uniqBy(
        _.sortBy(conversions, d => -d.created_at),
        d => d.id
      );
      vm.averageConversionPrice =
        _.sumBy(vm.conversions, d => d.price) / vm.conversions.length;
      vm.getDevicePercentage = getDevicePercentage;
      vm.conversionCountPerDevice = _.countBy(vm.conversions, d => d.device);
      vm.pagedConversions = vm.conversions;
      vm.chartData.devices = getDevicesChartData(vm.conversionCountPerDevice);
    });
  }

  function pageChanged() {
    const begin = vm.pagination.itemsPerPage * (vm.pagination.currentPage - 1);
    const end = begin + vm.pagination.itemsPerPage;
    const sortedConversions = _.orderBy(
      vm.conversions,
      [vm.sortCurrent],
      [vm.sortReverse ? 'desc' : 'asc']
    );
    vm.pagedConversions = sortedConversions.slice(begin, end);
  }

  function sortBy(field) {
    vm.sortCurrent = field;
    vm.sortReverse = !vm.sortReverse;
    vm.pageChanged();
  }

  function getDevicePercentage(deviceConversionCount) {
    const totalConversions = _.sum(vm.conversionCountPerDevice);
    return (deviceConversionCount / totalConversions) * 100;
  }

  function getDevicesChartData(devices) {
    let deviceSegment = [];
    _.each(devices, (i, d) => {
      deviceSegment.push({
        label: vm.getDeviceName(d),
        value: getDevicePercentage(i)
      });
    });
    return deviceSegment;
  }

  function isOnlyOneDay() {
    if(moment(vm.startAt).isSame(vm.endAt, 'd')) {
      return true;
    }
    return false;
  }

  function getCSV() {
    let rows = _.map(vm.conversions, cv => _.pick(cv, vm.fields));

    // sort before formatting date because
    // otherwise sorting by date wouldnt work properly...
    rows = _.orderBy(rows, [vm.sortCurrent], [vm.sortReverse ? 'desc' : 'asc']);

    _.each(rows, cv => {
      cv.price = cv.price / (10 ** vm.currency.fractionSize);
      cv.device = vm.getDeviceName(cv.device);
      cv.created_at = moment(new Date(cv.created_at)).format(CSV_DATE_FORMAT);
    });

    return rows;
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/campaign/list/conversions.js